import { render } from "./item-price-tiers.vue?vue&type=template&id=27aa50da&scoped=true"
import script from "./item-price-tiers.vue?vue&type=script&lang=js"
export * from "./item-price-tiers.vue?vue&type=script&lang=js"

import "./item-price-tiers.vue?vue&type=style&index=0&id=27aa50da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27aa50da"]])

export default __exports__